<template>
    <PropertyCards :properties="properties" />

    <!-- Сообщение, если объектов нет -->
    <div v-if="!loading && properties.length === 0" class="text-center text-muted py-5">
      Нет объектов
    </div>

    <PropertyPagination
      v-if="pagination.total > pagination.per_page"
      :current-page="currentPage"
      :total-pages="totalPages"
      @previous="previousPage"
      @next="nextPage"
    />
</template>


<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import PropertyCards from '../pages/property_list/PropertyCards.vue'
import PropertyPagination from '../pages/property_list/PropertyPagination.vue'
import PageHero from '../components/PageHero.vue'
import MiniFilterBar from '../components/MiniFilterBar.vue'


const props = defineProps({
  agencyId: {
    type: [String, Number],
    required: true
  }
})

const properties = ref([])
const filters = ref({
  main_category: '',
  property_type: '',
  property_subtype: ''
})

const pagination = ref({
  page: 1,
  per_page: 25,
  total: 0
})

const currentPage = computed(() => pagination.value.page)
const totalPages = computed(() => Math.ceil(pagination.value.total / pagination.value.per_page))

const fetchProperties = async () => {
  const params = new URLSearchParams({
    ...filters.value,
    page: pagination.value.page,
    sort: 'price',
    direction: 'asc'
  }).toString()

  try {
    const response = await fetch(`/api/v1/agencies/${props.agencyId}/properties?${params}`)
    const data = await response.json()
    properties.value = data.properties
    pagination.value.total = data.pagination.total
  } catch (error) {
    console.error('Ошибка загрузки объектов агентства:', error)
  }
}

const handleFilterUpdate = (newFilters) => {
  filters.value = newFilters
  pagination.value.page = 1
  fetchProperties()
}

const nextPage = () => {
  if (pagination.value.page < totalPages.value) {
    pagination.value.page++
    fetchProperties()
  }
}

const previousPage = () => {
  if (pagination.value.page > 1) {
    pagination.value.page--
    fetchProperties()
  }
}

onMounted(() => {
  fetchProperties()
})

// Если props.agencyId может меняться динамически:
watch(() => props.agencyId, () => {
  pagination.value.page = 1
  fetchProperties()
})
</script>
